
import { FETCH_ROLES, FETCH_USERS, FETCH_USERS_DATA, SAVE_USER, UPDATE_USER } from "../Dispatchers";
import { fetchAllRoles, fetchAllUsers, fetchAllUsersData, saveUser, updateUser, uploadUserImg } from "../service/AdminService";
import { formatError, formatSuccess } from "../service/AuthService";
import { fetchLoggedInUser, loaderAction } from "./UserActions";

export const fetchEmployeeList = (page,pageSize) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        fetchAllUsers(page,pageSize).then((response) => {
            dispatch({ type: FETCH_USERS, payload: response.data })
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))
        })
    }
}
export const fetchEmployeeListData = () => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        fetchAllUsersData().then((response) => {
            dispatch({ type: FETCH_USERS_DATA, payload: response.data })
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))
        })
    }
}
export const saveUserAction = (User) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        saveUser(User).then((response) => {
            dispatch({ type: SAVE_USER, payload: response.data })
            formatSuccess(response.apiMessage || response.data || 'User saved')
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(fetchEmployeeList())
            dispatch(loaderAction(false))
        })
    }
}
export const updateUserAction = (User) => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        updateUser(User).then((response) => {
            dispatch({ type: UPDATE_USER, payload: response.data })
            formatSuccess(response.apiMessage || response.data || 'User updated')
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(fetchEmployeeList())
            dispatch(loaderAction(false))
        })
    }
}
export const fetchRollList = () => {
    return (dispatch) => {
        dispatch(loaderAction(true))
        fetchAllRoles().then((response) => {
            dispatch({ type: FETCH_ROLES, payload: response.data })
        }).catch((error) => {
            formatError(error)
        }).finally(() => {
            dispatch(loaderAction(false))
        })
    }
}

export const uploadUserImage = (User) => {
    return (dispatch) => {
        uploadUserImg(User).then((response) => {
            formatSuccess(response.apiMessage || response.data || 'Image uploaded');
            dispatch(fetchLoggedInUser())
        }).catch((error) => {
            formatError(error)
        })
    }
}
